import React, { useEffect, useCallback, useRef, useState } from 'react';
import { Row, Col, message, Button } from 'antd';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPaymentMethodTypeList } from '../ducks/actions'
import { removePaymentMethodType, bulkRemovePaymentMethodTypes, updatePaymentMethodTypesOrder } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search';
import placeholderImg from "Assets/img/product-placeholder.png"
import DndListCard from 'Molecules/DndListCard';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { CloseCircleFilled, CheckCircleFilled } from '@ant-design/icons';
import { useTranslate } from 'Translate';

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.systems.paymentMethodTypes);
  const meta = useSelector((state) => state.systems.paymentMethodTypeOption);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const [list, setDataList] = useState([]);
  const [hasDirty, setHasDirty] = useState(false);
  const allowedEdit = allowed([AllRoles.SYSTEM.PAYMENT_METHOD_TYPE], 'write');
  const allowedDelete = allowed([AllRoles.SYSTEM.PAYMENT_METHOD_TYPE], 'delete');
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const i18n = useTranslate();
  const { t } = i18n;

  const colName = [
    {
      title: t("General.image"),
      dataIndex: 'image_url',
      key: 'image_url',
      className: 'enable-click',
      sorter: true,
      align: 'center',
      render: (text) => <img src={text || placeholderImg} width="50px" />
    },
    {
      title: t("General.code"),
      dataIndex: 'code',
      key: 'code',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("General.desc"),
      dataIndex: 'desc',
      key: 'desc',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("General.status"),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record) =>
        <div className='flex align-items-center'>
          <span className={text === "Active" ? "c-success" : "c-danger"}>
            {t(`General.${text?.toLowerCase()}`)}
          </span>
          {
            allowedEdit &&
            <Button type="link" onClick={() => onAction(record.id, text)}>
              {text === "Active" ? `(${t("General.deactivate")})` : `(${t("General.activate")})`}
            </Button>
          }
        </div>
    },
    {
      title: t("System.is_kiosk"),
      dataIndex: 'is_kiosk',
      key: 'is_kiosk',
      sorter: true,
      align: 'center',
      render: (text) => <span>{text === "1" ? <CheckCircleFilled className='c-success' style={{ fontSize: '20px' }} /> : <CloseCircleFilled className='c-danger' style={{ fontSize: '20px' }} />}</span>
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text, record) =>
        <ActionButton
          title="tender_media_type"
          btnAction1={!["CASH"].includes(record.code) ? () => navigate(`/payment-method-type/${record.id}`) : null}
          recordId={record.id}
          onRemove={(allowedDelete && !["CASH", "CARD", "EWALLET"].includes(record.code)) && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ];

  const addNew = () => navigate('/payment-method-type/add');

  const btnList = [
    {
      title: t("Product.confirm_reorder_list"),
      text: t("General.update_listing"),
      classes: 'b-success attendance-success',
      btnHidden: !hasDirty,
      action: () => onUpdateList()
    },
    {
      title: t("Confirm.remove_select_tender_media_types"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("New.tender_media_type")}`,
      classes: 'attendance-success',
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.tenderMediaTypeListQuery) {
      dispatch(getPaymentMethodTypeList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('tenderMediaTypeListQuery', 1, limit, '', '', null, props.setLoading));
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.tenderMediaTypeListQuery
      dispatch(getPaymentMethodTypeList(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  useEffect(() => {
    if (data) {
      setDataList(data.list);
    }
  }, [data])

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getPaymentMethodTypeList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('tenderMediaTypeListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading))
    } else {
      dispatch(getPaymentMethodTypeList(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('tenderMediaTypeListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading))
    }
  }

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        code: search.code
      };
      setSearchVal(searching);
      dispatch(getPaymentMethodTypeList(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('tenderMediaTypeListQuery', 1, limit, '', '', searching, props.setLoading))
    } else {
      setSearchVal(null);
      dispatch(getPaymentMethodTypeList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('tenderMediaTypeListQuery', 1, limit, '', '', null, props.setLoading))
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: ["CASH"].includes(record.code)
    }),
  };

  const onAction = async (recId, status) => {
    props.setLoading(true);

    const payload = {
      payment_method_type_id: recId,
      status_event: status === "Active" ? "deactivate" : "activate"
    }

    await removePaymentMethodType(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.update_tender_media_type_status"));
        setTimeout(() => dispatch(getPaymentMethodTypeList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('tenderMediaTypeListQuery', page, limit, '', '', searchVal, props.setLoading))
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onRemove = async (id) => {
    props.setLoading(true);

    const payload = {
      payment_method_type_id: id,
      status_event: 'remove'
    }

    await removePaymentMethodType(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.remove_tender_media_type"));
        setTimeout(() => dispatch(getPaymentMethodTypeList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('tenderMediaTypeListQuery', page, limit, '', '', searchVal, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      remark_types: JSON.stringify(selectedRowKeys)
    }

    await bulkRemovePaymentMethodTypes(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Success.remove_tender_media_types"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getPaymentMethodTypeList(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('tenderMediaTypeListQuery', 1, limit, '', '', null, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onUpdateList = async () => {
    props.setLoading(true);

    const payload = {
      payment_method_types: JSON.stringify(list?.map((d, i) => ({ id: d.id, position: i + 1 })))
    }
    await updatePaymentMethodTypesOrder(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.order_update_tender_media_types"));
        // setTimeout(() => callApi(), 500);
        setHasDirty(false);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  return (
    <Row gutter={[10, 10]}>
      <Col span={24}>
        <HeadingChip title={t("General.tender_media_types")} btnList={allowedEdit ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
      </Col>
      <Col span={24} className="clickRow">
        <DndListCard 
          setHasDirty={setHasDirty}
          list={list}
          setDataList={setDataList}
          Search={Search}
          onSearch={onSearch}
          searchVal={globalListQuery.tenderMediaTypeListQuery?.searchValue}
          field1={meta?.payment_method_types}
          ListData={list?.map(x => ({ ...x, key: x.id }))}
          onChange={onTableChange}
          ListCol={colName}
          rowSelection={allowedEdit && rowSelection}
          pagination={{
            total: data?.total_count,
            current: page,
            pageSize: limit
          }}
        />
      </Col>
    </Row>
  )
}